// extracted by mini-css-extract-plugin
module.exports = {"sectionHeadingWrapper":"index-module--sectionHeadingWrapper--32Ndy","sectionHeading":"index-module--sectionHeading--2K8rZ","shareBtn":"index-module--shareBtn--2fe_9"};